/* eslint-disable no-console */
import React from 'react'
import Button, { TYPES, SIZES } from '../../Button/index'
import { ICON_TYPES } from '../../Icon.v2/index'
import { Tabs, Tab } from '../../Tabs/index'
import { H5 } from '../../Heading/index'

const ButtonDemo = () => (
  <div className="button-demo">
    <Tabs>
      <Tab label="Buttons">
        <article className="button-demo">
          <H5>Inline Buttons</H5>
          <div className="buttons-inline">
            <Button
              type={TYPES.DEFAULT}
            >
              Default
            </Button>
            <Button
              type={TYPES.PRIMARY}
            >
              Primary
            </Button>
            <Button
              type={TYPES.SECONDARY}
            >
              Secondary
            </Button>
            <Button
              type={TYPES.TERTIARY}
            >
              Tertiary
            </Button>
            <Button
              type={TYPES.ROYAL}
            >
              Royal
            </Button>
            <Button
              type={TYPES.ICON_ROYAL}
              icon={ICON_TYPES.PLAY}
            >
              Royal
            </Button>
            <Button
              type={TYPES.PRIMARY}
              disabled
            >
              Disabled
            </Button>
            <Button
              type={TYPES.GHOST}
            >
              Ghost
            </Button>
            <Button
              type={TYPES.PILL}
            >
              Pill
            </Button>
            <Button
              type={TYPES.ICON}
              icon={ICON_TYPES.SHARE}
            >
              Icon
            </Button>
            <Button
              type={TYPES.ICON_PILL}
              icon={ICON_TYPES.SHARE}
            >
              Icon Pill
            </Button>
            <Button
              type={TYPES.ICON_FILL}
              icon={ICON_TYPES.PLUS}
              size={SIZES.SMALL}
            />
            <Button
              type={TYPES.ICON_FILL}
              icon={ICON_TYPES.SHARE}
            />
            <Button
              type={TYPES.ICON_FILL}
              icon={ICON_TYPES.PHONE}
              size={SIZES.LARGE}
            />
            <Button
              type={TYPES.LINK}
            >
              Link
            </Button>
          </div>

          <H5>Inverted Buttons</H5>

          <div className="buttons-inline buttons-inverted">
            <Button type={TYPES.PRIMARY} inverted>
              Primary inverted
            </Button>
            <Button type={TYPES.SECONDARY} inverted>
              Secondary inverted
            </Button>
          </div>

          <H5>Stacked Buttons</H5>

          <div className="buttons">
            <Button
              type={TYPES.DEFAULT}
              stacked
            >
              Default
            </Button>
            <Button
              type={TYPES.PRIMARY}
              stacked
            >
              Primary
            </Button>
            <Button
              type={TYPES.SECONDARY}
              stacked
            >
              Secondary
            </Button>
            <Button
              type={TYPES.TERTIARY}
              stacked
            >
              Tertiary
            </Button>
            <Button
              type={TYPES.ROYAL}
              stacked
            >
              Royal
            </Button>
            <Button
              type={TYPES.PRIMARY}
              disabled
              stacked
            >
              Disabled
            </Button>
            <Button
              type={TYPES.GHOST}
              stacked
            >
              Ghost
            </Button>
          </div>

          <div className="buttons-small">
            <Button
              type={TYPES.DEFAULT}
              size={SIZES.XSMALL}
              stacked
            >
              XSmall Default
            </Button>
            <Button
              type={TYPES.PRIMARY}
              size={SIZES.XSMALL}
              stacked
            >
              XSmall Primary
            </Button>
            <Button
              type={TYPES.SECONDARY}
              size={SIZES.XSMALL}
              stacked
            >
              XSmall Secondary
            </Button>
            <Button
              type={TYPES.TERTIARY}
              size={SIZES.XSMALL}
              stacked
            >
              XSmall Tertiary
            </Button>
            <Button
              type={TYPES.ROYAL}
              size={SIZES.XSMALL}
              stacked
            >
              XSmall Royal
            </Button>
            <Button
              type={TYPES.ICON_ROYAL}
              icon={ICON_TYPES.PLAY}
              size={SIZES.XSMALL}
              stacked
            >
              XSmall Royal
            </Button>
            <Button
              type={TYPES.PRIMARY}
              size={SIZES.XSMALL}
              stacked
              disabled
            >
              XSmall Disabled
            </Button>
            <Button
              type={TYPES.GHOST}
              size={SIZES.XSMALL}
              stacked
            >
              XSmall Ghost
            </Button>
          </div>

        </article>
      </Tab>
    </Tabs>
  </div>
)

export default ButtonDemo
